import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'What does LymphoriaX do?',
    answer: 'LymphoriaX is a liquid herbal formula that supports healthy lymphatic drainage to reduce puffiness, release water retention, and boost natural energy. It works by stimulating circulation, mobilizing trapped fluid, and promoting gentle drainage.'
  }, {
    question: 'How fast will I see results?',
    answer: 'Most women notice reduced puffiness within 7-10 days. Full benefits typically appear within 3-4 weeks of consistent use. 90%+ of users report visible changes in the first 2 weeks.'
  }, {
    question: 'How do I take it?',
    answer: 'Take 1-2 dropperfuls in water or juice each morning. For best results, use daily on an empty stomach. The liquid format ensures maximum absorption.'
  }, {
    question: 'Is it safe for daily use?',
    answer: "Yes! LymphoriaX is made with pure herbal ingredients and is gentle enough for daily use. It's third-party tested for purity and potency. Always consult your doctor if you have specific health concerns."
  }, {
    question: "What if it doesn't work for me?",
    answer: "We offer a 60-day money-back guarantee. If you don't feel the difference, simply return it for a full refund. No questions asked. We're confident you'll love the results."
  }, {
    question: 'Why is LymphoriaX better than other supplements?',
    answer: 'Unlike pills or capsules, our liquid formula is absorbed faster and more completely. We use premium herbal extracts, third-party testing, and have 12,847+ verified reviews. Plus, we offer a 60-day guarantee.'
  }];
  return <section className="py-24 bg-white" data-id="element-46">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-48">
          <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-49">
            Got Questions?
          </span>
          <h2 className="text-4xl font-bold text-[#1B5E20] mt-2" data-id="element-50">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-52" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-gradient-to-br from-[#F0FFF4] to-white rounded-xl shadow-md overflow-hidden border-2 border-transparent hover:border-[#10B981]/30 transition-all" data-id="element-53">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-white/50 transition-colors" data-id="element-54">
        <span className="font-bold text-[#1B5E20] text-lg" data-id="element-55">{question}</span>
        <ChevronDown className={`w-6 h-6 text-[#10B981] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-56" />
      </button>
      <AnimatePresence data-id="element-57">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-58">
            <div className="px-6 pb-6 text-[#374151] leading-relaxed border-t border-[#10B981]/10 pt-4" data-id="element-59">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}